import { render, staticRenderFns } from "./mock_chapter.vue?vue&type=template&id=564eccd3&scoped=true"
import script from "./mock_chapter.vue?vue&type=script&lang=js"
export * from "./mock_chapter.vue?vue&type=script&lang=js"
import style0 from "./mock_chapter.vue?vue&type=style&index=0&id=564eccd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564eccd3",
  null
  
)

export default component.exports